















































































import { Component, Vue, Prop } from 'vue-property-decorator';

import Table from '@/components/molecules/Table/Table.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import FilterTag from '@/componentsV2/molecules/FilterTag/FilterTag.vue';
import TableCard from '@/componentsV2/molecules/TableCard/TableCard.vue';
import EmptyStateTable from '@/componentsV2/molecules/EmptyStateTable/EmptyStateTable.vue';
import CoinsIcon from '@/components/icons/Coins.vue';

import { ICoinsPurchased } from '@/models/performance';

import { IPaginationTableHeader } from '@/utils/PaginationUtils';

@Component({
  components: {
    Table,
    TableCell,
    TableHeader,
    TableRow,
    FilterTag,
    TableCard,
    CoinsIcon,
    EmptyStateTable
  }
})
export default class CoinsPurchasedHistoryList extends Vue {
  @Prop() headers!: Record<string, IPaginationTableHeader>;
  @Prop() coinsPurchased!: ICoinsPurchased[];
  @Prop() campaignId?: string;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get styleTableCell() {
    return {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: '500',
      padding: '12px; 24px;'
    };
  }

  amountOfCoinsValue(item: ICoinsPurchased) {
    const totalAmount =
      item.businessTransaction.grossAmount / 100 +
      (item.businessTransaction.bonusAmount
        ? item.businessTransaction.bonusAmount / 100
        : 0);
    return totalAmount.toFixed(2);
  }

  amountOfCoinsDescription(item: ICoinsPurchased) {
    const grossAmount = (item.businessTransaction.grossAmount / 100).toFixed(2);
    const bonusAmount = item.businessTransaction.bonusAmount
      ? (item.businessTransaction.bonusAmount / 100).toFixed(2)
      : 0;

    return `(${grossAmount} Purchased + ${bonusAmount} Bonus)`;
  }

  detail(rowData: ICoinsPurchased) {
    this.$router.push(
      `/performance/customer-center/${
        rowData.businessTransaction.externalCustomerId
      }`
    );
  }
}
